export enum NotificationType {
    UnreadTotal = 'unread_total',
    UnreadMessages = 'unread_messages',
    UnreadMatchProposal = 'unread_match_proposal',
}

export type UserNotification = {
    [K in NotificationType]: number;
}
